























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppContainerComponent extends Vue {
  @Prop({default: false})
  public readonly isFluid!: boolean;
  @Prop({default: false})
  public readonly isNavbar!: boolean;
  @Prop({default: false})
  public readonly isBg!: boolean;
  @Prop({default: false})
  public readonly clearTopMargin!: boolean;
}
